import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormInputAmountProps } from './types';
import { generateSimpleRequiredOptionalPlaceholder } from '../utils';

// components
import { InputAmount } from '@ui';

const FormInputAmount: React.FC<FormInputAmountProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generateSimpleRequiredOptionalPlaceholder(validationRules || [], t);
  }, [validationRules, propsPlaceholder]);

  return <InputAmount {...rest} placeholder={placeholder} />;
};

export default React.memo(FormInputAmount);
